<template>
  
 <ion-footer :style="styleHeight">
    <!-- <div id="speech_text">
      BLAH
    </div> -->
    <div style="display: inline;" v-for="item in props.elements" v-bind:key="item.index">
      <ion-button size="medium" class="ion-text-wrap ion-no-margin ion-no-padding"
                  :disabled="item.disabled"
                  :class="{ button_count_1 : elements.length == 1 ,
                    button_count_2 : elements.length == 2 ,
                    button_count_3 : elements.length == 3 ,
                    button_count_4 : elements.length == 4 ,
                    button_count_5 : elements.length == 5 ,
                    button_count_6 : elements.length == 6 ,
                    button_count_7 : elements.length == 7 
                  }"

                  @click="onClickButton(item.index)">
          {{ item.label }}
      </ion-button>

    </div>
  </ion-footer>

</template>

<script setup>

import { IonIcon,IonButton, IonFooter} from '@ionic/vue';
import { caretBackOutline,caretForwardOutline, caretUpOutline , caretDownOutline } from 'ionicons/icons';
import { useConnectionStore } from '@/stores/connectionStore';

import { ref , watch } from 'vue'
import { useWindowSizeStore } from '../stores/windowSizeStore';
import { computed } from "@vue/reactivity"

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
const props = defineProps({
  elements : Array,
  trigger : {
    type : Number,
    default : 0
  }
})

const emit = defineEmits(['toolbar-click'])

const connectionStore = useConnectionStore()
const footerHeight = connectionStore.getToolbarHeight
const styleHeight = ref("height:" + footerHeight + "px;")

function onClickButton (index) {
  emit("toolbar-click",index)
}

</script>

<style scoped>

.button_count_1 {
  width : 50%;
  margin-left: 24%;
  margin-right: 24%;
  padding-left: 1%;
  padding-right : 1%;
}
.button_count_2 {
  width : 50%;
  padding-left: 0.5%;
  padding-right : 0.5%;
}

.button_count_3 {
  width : 33.2%;
  padding-left: 0.5%;
  padding-right : 0.5%;
}
.button_count_4 {
  width : 25%;
  padding-left: 0.5%;
  padding-right : 0.5%;
}

.button_count_5 {
  width : 20%;
  padding-left: 0.5%;
  padding-right : 0.5%;
}

.button_count_6 {
  width : 16.6%;
  padding-left: .5%;
  padding-right : .5%;
}
.button_count_7 {
  width : 14.2%;
  padding-left: 0.5%;
  padding-right : 0.5%;
}

#speech_text {
  opacity: 50%;
  font-style: italic;
  text-align: right;
  margin-right : 20px;
}
 /* ion-footer {
    --background: lightgray;
    --color: #fff;
} */

</style>